import { Box, Text } from "@wix/design-system";
import React, { useContext } from "react";
import { RicosContext } from "./../../ricos-context/index.js";
const GiphyEmptyState = ({ category }) => {
  const { t } = useContext(RicosContext);
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      height: "100%",
      alignContent: "center",
      display: "grid",
      textAlign: "center",
      fontSize: "14px",
      letterSpacing: "1px",
      gap: "12px"
    },
    /* @__PURE__ */ React.createElement(Text, { size: "medium", weight: "bold" }, category === "gifs" ? t("GiphyPlugin_Search_EmptyState_Title") : t("GiphyPlugin_Search_EmptyState_Title_Stickers")),
    /* @__PURE__ */ React.createElement(Text, { size: "small", weight: "thin" }, t("GiphyPlugin_Search_EmptyState_Text"))
  );
};
export {
  GiphyEmptyState
};
//# sourceMappingURL=giphy-empty-state.js.map
